export default "__VITE_ASSET__CM01ECij__"